import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import NewTopNavBar from "./NewTopNavBar";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
const ZohoIntegration = () => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalItems, setTotalItems] = useState(0);
    const [start, setStart] = useState(0); // Start from 1
    const [limit, setLimit] = useState(20); // Set default limit to 5
    const [currentPage, setCurrentPage] = useState(1); // Track the current page
    const [searchTerm, setSearchTerm] = useState(""); // Add state for search term
    const [dateStart, setDateStart] = useState("");
    const [dateEnd, setDateEnd] = useState("");
    const [initialLoader, setInitialLoader] = useState(true);
    const [selectedOptionDate, setSelectedOptionDate] = useState('1-day');
    const [allData, setAllData] = useState([]); // Store all search results
    const [dataLoading, setDataLoading] = useState(true)
    const loaderRef = useRef(null); // Ref for the loader element
    //
    //
    const [filteredTickets, setFilteredTickets] = useState([]); // Filtered tickets
    //   const [itemsPerPage, setItemsPerPage] = useState(10); // Items per page
    const [currentPageSearch, setCurrentPagesearch] = useState(1); // Current page
    //
    //
    let bearerToken = localStorage.getItem("jwt_token");

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const validStatuses = ["open", "resolved", "in progress", "closed"]; // List of valid Jira statuses
    const options = [
        // { id: "select", label: "Select" },
        { id: "default", label: "Default Search" },
        { id: "date", label: "Date Duration Search" },
        { id: "username", label: "User Name Search" },
    ];

    //   const [selectedOption, setSelectedOption] = useState(options[0].id);
    const [selectedOption, setSelectedOption] = useState("default");

    const handleChange = (event) => {
        // console.log(event.target.value);
        // setSelectedOption(event.target.value);
        setTableData([])
        setAllData([])
        setCurrentPage(1)
        setSelectedOption("default");
        console.log("line47=", event.target.value)
        setSelectedOptionDate(event.target?.value);
        setSearchTerm("");
        setDateStart("");
        setDateEnd("");
        setDataLoading(true)

        // setSelectedOption(parseInt(event.target.value, 10));
    };
    const isNumberValid = (input) => {
        const numberRegex = /^-?\d+(\.\d+)?$/;
        return numberRegex.test(input);
    };
    // Fetch data from the API per page
    const fetchData = async (start, limit, searchTerm = "") => {
        setLoading(true);
        try {
            // const jqlQuery = ` AND (summary ~ "${searchTerm}" OR description ~ "${searchTerm}" OR status = "${searchTerm}")`;

            //

            const statusQuery = validStatuses.includes(searchTerm.toLocaleLowerCase())
                ? `status = "${searchTerm}"`
                : ""; // If not a valid status, leave the status query empty
            // id = "${searchTerm}" OR
            // Build the JQL query
            const isInteger = /^\d+$/.test(searchTerm);

            //

            const result = await axios.get(
                `http://localhost:3060/tickets/issue/get-all-ticket`,
                {
                    params: {
                        email: "diya@silfratech.com",
                        index: start,
                        range: limit,
                    },
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("line33=", result.data);
            setInitialLoader(false);
            // setAllData(matchedTickets);
            setTableData(result.data.message); // Store data in tableData
            setTotalItems(result.data?.totalLength - 1); // Store total item count for pagination
        } catch (error) {
            console.error("Error fetching data", error);
        }
        setLoading(false);
    };
    //

    const baseUrl = "http://localhost:3060/tickets/issue/get-all-ticket";
    const email = "diya@silfratech.com";
    const rangeNew = 100; // Range per API cal

    // /
    const searchData = async (start, limit, searchTerm = "") => {
        // alert("sdf")
        // setTotalItems(0)
        // setTableData([]);
        setDataLoading(true)
        console.log({ selectedOption });
        console.log({ dateStart }, { dateEnd });

        const startDate = new Date(dateStart);
        const endDate = new Date(dateEnd);

        if (startDate > endDate) {
            toast.error(
                "Invalid dates: 'Start Date' cannot be grater than 'End Date'."
            );
            return;
        }

        // setLoading(true);
        //  OR status = "${searchTerm}")
        try {
            // const jqlQuery = `project=10001 AND (summary ~ "${searchTerm}" OR description ~ "${searchTerm}")`;
            const statusQuery = validStatuses.includes(searchTerm.toLocaleLowerCase())
                ? `status = "${searchTerm}"`
                : ""; // If not a valid status, leave the status query empty
            // id = "${searchTerm}" OR
            // Build the JQL query

            const isInteger = /^\d+$/.test(searchTerm);
            let url = "";
            if (isInteger) {
                //   url = `http://localhost:3060/tickets/issue/${searchTerm}`;
                const result = await axios.get(
                    `http://localhost:3060/tickets/issue/${searchTerm}`,
                    {
                        params: {
                            email: "diya@silfratech.com",
                            index: start,
                            range: limit,
                        },
                        headers: {
                            Authorization: `Bearer ${bearerToken}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                setTableData(result.data); // Store data in tableData
                // setTotalItems(result.data.total - 1); // Store total item count for pagination
                setTotalItems(0);
            } else {

                let index = 1; // Starting index
                let totalLength = 0; // Total tickets
                const matchedTickets = []; // Array to store matched records
                let stopFetching = false; // Flag to terminate the loop

                let startDate = null;
                let endDate = new Date(); // Today

                if (selectedOptionDate === "1_week") {
                    startDate = new Date();
                    startDate.setDate(endDate.getDate() - 7); // 1 week ago
                } else if (selectedOptionDate === "1_month") {
                    startDate = new Date();
                    startDate.setMonth(endDate.getMonth() - 1); // 1 month ago
                } else if (selectedOptionDate === "3_months") {
                    startDate = new Date();
                    startDate.setMonth(endDate.getMonth() - 3); // 3 months ago
                } else if (selectedOptionDate === "1-day") {
                    // alert('1day')
                    startDate = new Date();
                    startDate.setDate(endDate.getDate() - 1);
                }
                else if (selectedOptionDate === "custom") {
                    // Custom date range provided
                    if (dateStart && dateEnd) {
                        startDate = new Date(dateStart); // Custom start date
                        endDate = new Date(dateEnd); // Custom end date
                    } else {
                        setDataLoading(false)
                        return <div>Give Start Date And End Date</div>

                    }
                } else if (searchTerm.trim() != "") {

                    setTableData([]);
                    setAllData([])
                }
                do {
                    // Construct the API URL with query parameters
                    const url = `${baseUrl}?email=${email}&index=${index}&range=${rangeNew}`;
                    console.log(`Fetching from index ${index}`);

                    // Fetch data from the API
                    const response = await axios.get(url, {
                        headers: {
                            Authorization: `Bearer ${bearerToken}`,
                            "Content-Type": "application/json",
                        },
                    });
                    const data = response.data;
                    setLoading(false)
                    // Update total length (only once, during the first call)
                    totalLength = totalLength || data.totalLength;

                    const currentBatch = data.message.filter((ticket) => {
                        const { Title, UserName, Description, Created_on } = ticket;

                        // Parse Created_on date into a valid Date object
                        const ticketDate = new Date(
                            Created_on.replace(
                                /^(\d{2})-(\d{2})-(\d{4})/, // Regex for DD-MM-YYYY
                                "$2/$1/$3" // Convert to MM/DD/YYYY for parsing
                            )
                        );

                        // Check if the ticket's Created_on date falls within the range
                        let isWithinDateRange = true;
                        if (startDate) {
                            isWithinDateRange =
                                ticketDate >= startDate && ticketDate <= endDate;
                        }

                        // Apply search term filtering
                        const matchesSearchTerm =
                            (Title &&
                                Title.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (UserName &&
                                UserName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (Description &&
                                Description.toLowerCase().includes(searchTerm.toLowerCase()));
                        // if (searchTerm.trim() != "") {
                        //     return matchesSearchTerm
                        // } else {
                        return isWithinDateRange && matchesSearchTerm;
                        // }
                    });

                    // Add the matched tickets to the array
                    matchedTickets.push(...currentBatch);

                    // Update the state incrementally to show results progressively
                    // setAllData((prevData) => [...prevData, ...currentBatch]); // Incrementally update all data
                    // setTotalItems(matchedTickets.length); // Update total items

                    // Check if the current batch contains any data before the comparison date
                    // if (comparisonDate) {
                    //     const allDatesBeforeComparison = data.message.every((ticket) => {
                    //         const ticketDate = ticket.CreatedDate ? new Date(ticket.CreatedDate) : null;
                    //         return ticketDate && ticketDate < comparisonDate;
                    //     });

                    //     if (allDatesBeforeComparison) {
                    //         stopFetching = true; // Set flag to terminate loop
                    //     }
                    // }
                    // Increment index for the next batch
                    index += rangeNew;
                } while (index <= totalLength); // Continue until all tickets are fetched
                setAllData(matchedTickets);

                // Set the initial display data (first page)
                // setDisplayData(matchedTickets.slice(0, itemsPerPage));
                setTableData(matchedTickets.slice(0, limit)); // Display first page initially

                console.log("Matched Tickets:", matchedTickets);
                // setTableData(matchedTickets);
                setTableData(matchedTickets.slice(0, limit)); // Display first page initially
                setInitialLoader(false);
                // setTotalItems(limit);
                setDataLoading(false)
            }
        } catch (error) {
            setDataLoading(false)
            setTableData([]);
            setTotalItems(0);
            console.error("Error fetching data", error);
        }
        setLoading(false);
    };
    // if (searchTerm == "") {
    //   fetchData(start, limit, searchTerm);
    // }



    //
    // alert(currentPage)
    // Load more data when user scrolls to the bottom
    const loadMoreData = () => {
        // alert('load')
        setLoading(true);
        console.log({ currentPage })
        const nextPage = currentPage + 1;
        const startIndex = (nextPage - 1) * limit;
        const endIndex = startIndex + limit;
        console.log({ startIndex });
        console.log({ endIndex });
        console.log('288allData=', allData.length)
        console.log({ allData })
        const newData = allData.slice(startIndex, endIndex);
        console.log({ newData })
        if (newData.length > 0) {
            setTableData((prevData) => [...prevData, ...newData]);
            setCurrentPage(nextPage);
        }
        setLoading(false);
    };
    console.log("line200tableData=", tableData);
    // Use Intersection Observer to detect when the loader is visible
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {

                if (entries[0].isIntersecting) {
                    loadMoreData();
                }
            },
            { threshold: 1.0 }
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) {
                observer.unobserve(loaderRef.current);
            }
        };
    }, [allData, currentPage, loading]);

    // 

    useEffect(() => {
        // if (searchTerm == "") {
        //   fetchData(start, limit, searchTerm);
        // } // Fetch data based on start, limit, and search term
        // else {
        //   searchData(start, limit, searchTerm);
        // }

        const delayDebounceFn = setTimeout(() => {
            if (searchTerm.trim() !== "" || selectedOptionDate.trim() != "") {
                searchData(start, limit, searchTerm);
            } else {
                fetchData(start, limit, searchTerm);
            }
        }, 1000);
        return () => clearTimeout(delayDebounceFn);
    }, [start, limit, searchTerm, selectedOptionDate]);

    const columns = useMemo(
        () => [
            {
                Header: "Ticket ID",
                accessor: "Ticket_ID",
                disableSortBy: false,
                Cell: ({ value }) => (
                    <a
                        target="_blank"
                        href={`https://projectsapi.zoho.com/restapi/portal/660858286/projects/1211941000014235993/bugs/${value}`}
                        style={{ textDecoration: "none", color: "#007bff" }}
                    >
                        {value}
                    </a>
                ),
            },
            {
                Header: "Ticket Created",
                accessor: "Created_on",
                // Cell: ({ value }) => {
                //     const date = new Date(value);
                //     const formattedDate = date.toLocaleDateString("en-GB", {
                //         day: "2-digit",
                //         month: "short",
                //         year: "numeric",
                //     });
                //     const formattedTime = date.toLocaleTimeString("en-GB", {
                //         hour: "numeric",
                //         minute: "numeric",
                //         hour12: true,
                //     });
                //     return `${formattedDate}, ${formattedTime}`;
                // },
            },
            {
                Header: "User Name",
                accessor: "UserName",
                disableSortBy: false,
            },
            {
                Header: "Ticket Description",
                accessor: "Description",
                disableSortBy: true,
                Cell: ({ value }) => {
                    const stripHtml = (str) => str.replace(/<[^>]*>/g, ""); // Remove HTML tags
                    const cleanValue = stripHtml(value); // Strip tags from value
                    return cleanValue.length > 90
                        ? `${cleanValue.slice(0, 90)}...`
                        : cleanValue;
                },
            },
            {
                Header: " Ticket Status",
                accessor: "Status",
                disableSortBy: false,
            },
            {
                Header: "Ticket Updated",
                accessor: "Updated_on",
                // Cell: ({ value }) => {
                //     const date = new Date(value);
                //     const formattedDate = date.toLocaleDateString("en-GB", {
                //         day: "2-digit",
                //         month: "short",
                //         year: "numeric",
                //     });
                //     const formattedTime = date.toLocaleTimeString("en-GB", {
                //         hour: "numeric",
                //         minute: "numeric",
                //         hour12: true,
                //     });
                //     return `${formattedDate}, ${formattedTime}`;
                // },
                disableSortBy: false,
            },
        ],
        [allData]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        setPageSize: tableSetPageSize,
        state: { pageSize: currentPageSize },
    } = useTable(
        {
            columns,
            data: tableData,
            manualPagination: true, // Manually handle pagination
            pageCount: Math.ceil(totalItems / limit),
        },
        useSortBy,
        usePagination
    );

    const handlePageSizeChange = (e) => {
        const newPageSize = Number(e.target.value);
        setLimit(newPageSize); // Update limit instead of pageSize
        tableSetPageSize(newPageSize);
        setStart(1); // Reset start when page size changes
        // setCurrentPage(1); // Reset to first page
    };

    const handleNextPage = () => {
        if (currentPage * limit < totalItems) {
            const newStart = start + limit;
            setStart(newStart); // Increment start by limit
            // setCurrentPage(currentPage + 1); // Go to the next page
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            const newStart = start - limit;
            setStart(newStart); // Decrement start by limit
            // setCurrentPage(currentPage - 1); // Go to the previous page
        }
    };

    // Handle page number click
    const handlePageClick = (pageNumber) => {
        const newStart = (pageNumber - 1) * limit;
        setStart(newStart);
        // setCurrentPage(pageNumber);
    };

    // Render page numbers
    const totalPages = Math.ceil(totalItems / limit);
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    //
    // Function to get a subset of page numbers for display
    const getVisiblePages = (currentPage, totalPages) => {
        const visiblePages = [];
        const maxVisibleButtons = 5; // Maximum number of buttons to display at a time

        if (totalPages <= maxVisibleButtons) {
            // Show all pages if they are fewer than maxVisibleButtons
            for (let i = 1; i <= totalPages; i++) {
                visiblePages.push(i);
            }
        } else {
            if (currentPage <= 5) {
                // Show first few pages with ellipses at the end
                // visiblePages.push(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "end-ellipsis");
                visiblePages.push(1, 2, 3, 4, 5, 6, "end-ellipsis");
            } else if (currentPage > totalPages - 5) {
                // alert("dfgdfg")
                // Show last few pages with ellipses at the start
                // visiblePages.push("start-ellipsis", totalPages - 9, totalPages - 8, totalPages - 7, totalPages - 6, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
                visiblePages.push(
                    "start-ellipsis",
                    totalPages - 5,
                    totalPages - 4,
                    totalPages - 3,
                    totalPages - 2,
                    totalPages - 1,
                    totalPages
                );
            } else {
                // alert("e")
                // Show pages around the current page with ellipses on both sides
                visiblePages.push(
                    "start-ellipsis",
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    currentPage + 2,
                    currentPage + 3,
                    currentPage + 4,
                    currentPage + 5,
                    // currentPage + 6,
                    // currentPage + 7,
                    // currentPage + 8,
                    // currentPage + 9,
                    // currentPage + 10,
                    "end-ellipsis"
                );
            }
        }

        console.log({ visiblePages });

        return visiblePages;
    };

    const visiblePages = getVisiblePages(currentPage, totalPages);
    //
    const handleSearch = (e) => {
        e.preventDefault();
        setStart(0); // Reset to the first page
        searchData(0, limit, searchTerm);
        // setCurrentPage(1);
    };

    //

    // Handle page change
    const handlePageChange = (page) => {
        // setCurrentPage(page);
        const startIndex = (page - 1) * limit;
        const endIndex = startIndex + limit;
        setTableData(allData.slice(startIndex, endIndex));
    };

    // Generate pagination buttons
    const generatePagination = () => {
        const totalPages = Math.ceil(totalItems / limit);
        const buttons = [];

        if (currentPage > 1) {
            buttons.push(
                <Button key="prev" onClick={() => handlePageChange(currentPage - 1)}>
                    Prev
                </Button>
            );
        }

        for (let i = 1; i <= totalPages; i++) {
            if (
                i === 1 ||
                i === totalPages ||
                (i >= currentPage - 2 && i <= currentPage + 2)
            ) {
                buttons.push(
                    <Button
                        key={i}
                        onClick={() => handlePageChange(i)}
                        style={{
                            fontWeight: i === currentPage ? "bold" : "normal", backgroundColor:
                                i === currentPage ? "#007bff" : "#fff",
                            color: i === currentPage ? "#fff" : "#000",
                        }}
                    >
                        {i}
                    </Button>
                );
            } else if (
                (i === currentPage - 3 || i === currentPage + 3) &&
                i !== 1 &&
                i !== totalPages
            ) {
                buttons.push(<span key={`ellipsis-${i}`}>...</span>);
            }
        }

        if (currentPage < totalPages) {
            buttons.push(
                <Button style={{ marginLeft: "10px", padding: "5px 10px" }} key="next" onClick={() => handlePageChange(currentPage + 1)}>
                    Next
                </Button>
            );
        }

        return buttons;
    };

    // 
    return (
        <div className="">
            {/* <div className="header bg-dark">
                <div className="px-3 py-2">
                    <img
                        src="https://silfratech.com/wp-content/uploads/2016/06/silfra-logo-150-e1600848356342.png"
                        alt=""
                    />
                </div>
            </div> */}
            <NewTopNavBar />
            <div className="p-4 px-5">
                <h2 style={{ fontWeight: "bold" }} className="text-center fw-bold">
                    My Tickets
                </h2>
                {/* Search Form */}
                {!initialLoader ? (
                    <div>
                        <div className="d-flex justify-content-between px-5 ">
                            <div className="py-4">
                                <select
                                    id="categorySelect"
                                    className="d-none"
                                    value={currentPageSize}
                                    onChange={handlePageSizeChange}
                                    style={{}}
                                >
                                    {[10, 20, 30].map((size) => (
                                        <option key={size} value={size}>
                                            Show {size}
                                        </option>
                                    ))}
                                </select>
                                {/* <span style={{ marginLeft: "20px" }}>
                                    Showing items {start + 1} to {Math.min(start + limit)} of{" "}
                                    {totalItems + 1}
                                </span> */}
                                <span style={{ marginLeft: "20px" }}>
                                    {limit * currentPage > allData.length ? allData.length : limit * currentPage} of{" "}
                                    {allData.length}
                                </span>
                            </div>
                            <div className="d-none">
                                <label className="pe-2" htmlFor="dropdown">
                                    Select an option:
                                </label>
                                <select
                                    id="categorySelect"
                                    value={selectedOption}
                                    onChange={handleChange}
                                >
                                    {options.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                {" "}
                                <select
                                    id="categorySelect"
                                    value={selectedOptionDate}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <option value='1-day'>Last 24 Hours</option>
                                    <option value="1_week">Current Week </option>
                                    <option value="1_month">Current Month</option>
                                    <option value="3_months">Last 3 Months</option>
                                    <option value="custom">Custom Date</option>
                                </select>
                            </div>
                            <div>
                                {selectedOptionDate === "custom" && (
                                    <form onSubmit={(e) => handleSearch(e)} className="d-flex ">
                                        <label className="pe-2" htmlFor="dateStart">
                                            Start Date:
                                        </label>
                                        <input

                                            className=""
                                            value={dateStart}
                                            type="date"
                                            id="categorySelect"
                                            onChange={(e) => setDateStart(e.target.value)}
                                        />
                                        <label className="px-2" htmlFor="dateEnd">
                                            End Date:
                                        </label>
                                        <input
                                            value={dateEnd}
                                            type="date"
                                            id="categorySelect"
                                            onChange={(e) => setDateEnd(e.target.value)}
                                        />
                                        <Button
                                            className="ms-2"
                                            type="submit"
                                            style={{ margin: "0", padding: "5px  15px" }}
                                        >
                                            Search
                                        </Button>
                                    </form>
                                )}
                            </div>
                            <div className="">
                                {selectedOption === "default" && (
                                    <form onSubmit={(e) => handleSearch(e)} className="d-flex ">
                                        <input
                                            type="text "
                                            className="form-control me-1"
                                            // by summary, description, or status
                                            placeholder="Search"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <Button
                                            className=""
                                            type="submit"
                                            style={{ margin: "0", padding: "5px  15px" }}
                                        >
                                            Search
                                        </Button>
                                    </form>
                                )}
                                {selectedOption === "username" && (
                                    <form onSubmit={(e) => handleSearch(e)} className="d-flex ">
                                        <input
                                            type="text "
                                            className="form-control me-1"
                                            // by summary, description, or status
                                            placeholder="Search"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <Button
                                            className=""
                                            type="submit"
                                            style={{ margin: "0", padding: "5px  15px" }}
                                        >
                                            Search
                                        </Button>
                                    </form>
                                )}
                                {selectedOption === "date" && (
                                    <form onSubmit={(e) => handleSearch(e)} className="d-flex ">
                                        <label className="pe-2" htmlFor="dateStart">
                                            Start Date:
                                        </label>
                                        <input
                                            className=""
                                            value={dateStart}
                                            type="date"
                                            id="dateStart"
                                            onChange={(e) => setDateStart(e.target.value)}
                                        />
                                        <label className="px-2" htmlFor="dateEnd">
                                            End Date:
                                        </label>
                                        <input
                                            value={dateEnd}
                                            type="date"
                                            id="dateEnd"
                                            onChange={(e) => setDateEnd(e.target.value)}
                                        />
                                        <Button
                                            className="ms-2"
                                            type="submit"
                                            style={{ margin: "0", padding: "5px  15px" }}
                                        >
                                            Search
                                        </Button>
                                    </form>
                                )}
                            </div>
                        </div>
                        <div className="px-5">
                            <table
                                {...getTableProps()}
                                style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    border: "1px solid #ddd",
                                    textAlign: "center",
                                }}
                            >
                                <thead>
                                    {headerGroups.map((headerGroup) => (
                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <th
                                                    {...column.getHeaderProps(
                                                        column.getSortByToggleProps()
                                                    )}
                                                    style={{
                                                        padding: "10px",
                                                        borderBottom: "2px solid #ddd",
                                                        borderRight: "2px solid #ddd",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {column.render("Header")}
                                                    <span>
                                                        {column.isSorted
                                                            ? column.isSortedDesc
                                                                ? " 🔽"
                                                                : " 🔼"
                                                            : ""}
                                                    </span>
                                                </th>
                                            ))}
                                        </tr>
                                    ))}
                                </thead>
                                {/* {tableData} */}
                                {tableData.length > 0 ? (
                                    <tbody {...getTableBodyProps()}>
                                        {loading ? (
                                            <tr>
                                                <td
                                                    colSpan="6"
                                                    style={{ textAlign: "center", height: "50vh" }}
                                                >
                                                    <Spinner animation="border" />
                                                </td>
                                            </tr>
                                        ) : (
                                            page.map((row) => {
                                                prepareRow(row);
                                                return (
                                                    <tr {...row.getRowProps()}>
                                                        {row.cells.map((cell) => (
                                                            <td
                                                                {...cell.getCellProps()}
                                                                style={{
                                                                    padding: "10px",
                                                                    borderBottom: "1px solid #ddd",
                                                                }}
                                                            >
                                                                {cell.render("Cell")}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                ) : !dataLoading ? (
                                    <h5 colSpan="6"
                                        style={{ textAlign: "center" }} className="text-center py-3">No Data Found</h5>
                                ) : <tr colSpan="8"
                                    style={{ textAlign: "center" }} className="d-flex justify-content-center mb-5">
                                    {/* console.log("line205") */}
                                    {/* <Spinner /> */}

                                    <h4 className="pt-2">Loading...</h4>
                                </tr>}
                            </table>
                        </div>

                        {/* Pagination Controls */}
                        {searchTerm.length == "" && selectedOptionDate == "" ?
                            <div
                                className="px-5 d-none"
                                style={{ marginTop: "20px", textAlign: "center" }}
                            >
                                <Button
                                    onClick={handlePreviousPage}
                                    disabled={currentPage === 1}
                                    style={{ marginRight: "10px", padding: "5px 10px" }}
                                >
                                    Prev
                                </Button>
                                {tableData.map((number, index) =>
                                    number === "start-ellipsis" || number === "end-ellipsis" ? (
                                        <span
                                            key={number + index} // Unique key for ellipses
                                            style={{
                                                margin: "0 5px",
                                                color: "#888",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            ...
                                        </span>
                                    ) : (
                                        <Button
                                            key={number}
                                            onClick={() => handlePageClick(number)}
                                            style={{
                                                padding: "2px 10px",
                                                width: "40px",
                                                margin: "0 5px",
                                                backgroundColor:
                                                    number === currentPage ? "#007bff" : "#fff",
                                                color: number === currentPage ? "#fff" : "#000",
                                            }}
                                        >
                                            {number}
                                        </Button>
                                    )
                                )}
                                <Button
                                    onClick={handleNextPage}
                                    disabled={currentPage === totalPages}
                                    style={{ marginLeft: "10px", padding: "5px 10px" }}
                                >
                                    Next
                                </Button>
                            </div>


                            : <div className="px-5 pagination d-none"
                                style={{ marginTop: "20px", textAlign: "center", display: 'flex', justifyContent: 'center' }}>
                                {generatePagination()}
                            </div>
                        }
                        {/* search pagenation end */}
                    </div>
                ) : (
                    <div className="text-center pt-5">
                        <Spinner />
                    </div>
                )}

                {/*  */}
                {loading && <div className="text-center pt-5">
                    <Spinner />
                </div>}

                {/* Loader element for Intersection Observer */}
                <div ref={loaderRef} style={{ height: "50px" }}></div>
                {/*  */}
            </div>
        </div>
    );
};

export default ZohoIntegration;
